export default __webpack_public_path__ + "static/media/ErikaMoya.7207534e.png";